import { MetricBand } from '@/components/dashboard/MetricBand';
import { useFirebaseAnalytics } from '@/hooks/useDashboard';

function sessionsHint(change: number | null | undefined): string | undefined {
  if (change == null) return undefined;
  if (change === 0) return '= dia anterior';
  return `${change > 0 ? '+' : ''}${change}% vs. dia anterior`;
}

// O GA4 atrasa 1–2 dias: a faixa mostra o último dia já processado.
function referenceCaption(date: string | null | undefined): string {
  if (!date) return 'sem dado recente';
  const [, month, day] = date.split('-');
  return `dia ${day}/${month}`;
}

/** Analytics real do Firebase (GA4 Data API) + crash-free aproximado via app_logs. */
export function FirebaseAnalyticsCard() {
  const { data, isLoading, isError, error } = useFirebaseAnalytics();

  const errorMessage = isError
    ? (error as { response?: { data?: { message?: string } } })?.response?.data?.message ||
      'Não foi possível carregar o Analytics. Verifique a integração com o GA4.'
    : undefined;

  return (
    <MetricBand
      title="Analytics"
      caption={referenceCaption(data?.referenceDate)}
      loading={isLoading}
      error={errorMessage}
      metrics={[
        {
          label: 'Sessões',
          value: (data?.sessions24h ?? 0).toLocaleString(),
          hint: sessionsHint(data?.sessionsChange),
        },
        { label: 'Eventos', value: (data?.events24h ?? 0).toLocaleString() },
        {
          label: 'Crash-free',
          value: `${data?.crashFreeRate ?? 0}%`,
          hint: 'meta 99%',
          valueClassName: (data?.crashFreeRate ?? 0) >= 99 ? 'text-tertiary' : 'text-warning',
        },
        {
          label: 'Instalações',
          value: (data?.installs24h ?? 0).toLocaleString(),
          hint: 'iOS e And.',
        },
        {
          label: 'Desinstalações',
          value: (data?.uninstalls24h ?? 0).toLocaleString(),
          hint: 'Android',
        },
      ]}
    />
  );
}
